<template>
  <div>
    <Header/>
    <div class="attention">
      <div class="title">{{message.message}}</div>
      <div v-if="messageshow">
        <div class="item2">
          <div style="margin-top:60px;width:100%" class="item" >
            <div class="name">考试名称：</div>
            <div class="main" style="flex-grow:1">{{message.data.examtitle}}</div>
          </div>
        </div>
        <div class="item2">
          <div class="item" style="width:100%" >
            <div class="name">考试描述：</div>
            <div class="main" style="flex-grow:1">{{message.data.examdescrip}}</div>
          </div>
        </div>
        <div class="item2">
          <div class="item" style="width:350px">
            <div class="name">考试总分：</div>
            <div>{{message.data.epscore}}分</div>
          </div>
          <div class="item" style="width:350px">
            <div class="name">及格分数：</div>
            <div>{{message.data.examscore}}分</div>
          </div>
        </div>
        <div class="item2">
          <div class="item" style="width:350px">
            <div class="name">考试时间：</div>
            <div>{{formate(message.data.examstartime,message.data.examendtime)}}</div>
          </div>
          <div class="item" style="width:350px">
            <div class="name">考试时长：</div>
            <div>{{message.data.examtime}}分钟</div>
          </div>
        </div>
        <div class="item2">
          <div class="item">
            <div class="name">可作答次数：</div>
            <div class="main">{{message.data.examnumless|examformate}}</div>
          </div>
        </div>
      </div>

      <div class="item2" style="justify-content: space-around;">
        <div :class="{button:true,disabled:disable}" @click="createxam">开始做答</div>
        <div class="button" @click="back">返回</div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../../components/header";
import { examsession, ExamAnswer_getInfo } from "../../assets/js/api.js";
import fun from "../../assets/js/fun.js";
export default {
  data() {
    return {
      message: {
        data: {
          action: "",
          epcount: 50,
          epitem: 0,
          epscore: 100,
          eptype: 3,
          examcue: "",
          examdecide: 0,
          examdescrip: "",
          examendtime: 1572364800,
          examhistory: 0,
          examid: 5,
          examnum: 1,
          exampid: 11,
          examscore: 60,
          examstartime: 1560528000,
          examtime: 60,
          examtitle: "",
          examunlimt: 0
        }
      },
      disable: false,
      messageshow: true
    };
  },
  components: {
    Header
  },
  filters: {
    examformate(data) {
      if (data == -1) {
        return "无限制";
      } else {
        return data + "次";
      }
    }
  },
  mounted() {
    if (this.$route.query.id) {
      this.getdata(this.$route.query.id);
    } else {
      this.back();
    }
  },
  methods: {
    formate(data, data2) {
      if (data) {
        return fun.formatetime(data) + "-" + fun.formatetime(data2);
      }
      return "无限制";
    },
    createxam() {
      if (this.disable) {
        return;
      }
      examsession(this.message.data).then(res => {
        if (res.data.code == 200 || res.data.code == 202) {
          this.$router.push("/exampaper");
        }
      });
    },
    getdata(data) {
      ExamAnswer_getInfo({ examid: data }).then(res => {
        if (res.data.code == 200) {
          this.message = res.data;
          this.disable = false;
        } else if (res.data.code == 202) {
          this.message = res.data;
          this.disable = false;
          this.messageshow = false;
        } else if (res.data.code == 203) {
          this.message = res.data;
          this.disable = true;
        } else if (res.data.code == 204) {
          this.message = res.data;
          this.disable = true;
        } else if (res.data.code == 205) {
           this.messageshow = false;
           this.message.message = "该考试未开始";
           this.disable = true;
        } else if (res.data.code == 407) {
           this.messageshow = false;
           this.message.message = "没有权限";
           this.disable = true;
        }  else {
          this.$Notice.warning({ title: "信息提示", desc: res.data.message });
        }
      });
    },
    back() {
      if(window.sessionStorage.getItem('type')=='2'){
        this.$router.push('/login')
        return
      }
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="css" scoped>
.attention {
  width: 700px;
  margin: 60px auto;
}
.title {
  line-height: 60px;
  font-size: 30px;
  color: #4b51ff;
  text-align: center;
  font-weight: bold;
}
.item {
  display: flex;
  justify-content: flex-start;
  margin-top: 30px;
  line-height: 30px;
  font-size: 16px;
  color: #7d818a;
  width: 100%;
}
.item .name {
  width: 120px;
  font-weight: bold;
  color: #4e5463;
  font-size: 18px;
  text-align: right;
}
.item div:last-child {
  text-align: left;
}
.item2 .item div:last-child {
  width: 200px;
}
.item .main {
  width: 600px;
  text-align: left;
}
.item2 {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  line-height: 30px;
  font-size: 16px;
  color: #7d818a;
}
.item2 .item {
  margin-top: 0;
}
.button {
  width: 130px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  background: #5359ff;
  color: #fff;
  font-size: 14px;
  margin-top: 60px;
  border-radius: 3px;
}
.button.disabled {
  background: #d1d6e1;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/pages/testlists/attention.vue